var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeClosed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    className: "bob-core-components-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "icons/_tint/eye-closed"
  }, /*#__PURE__*/React.createElement("path", {
    className: "primarytint",
    d: "M11.999 6.5c3.842 0 7.277 2.064 8.947 5.27l.035.088a.48.48 0 0 1-.037.36 8.985 8.985 0 0 1-1.061 1.57 10.685 10.685 0 0 1-4.313 3.072c-1.16.414-2.364.64-3.571.64-3.813 0-7.267-2.08-8.944-5.288l-.035-.087a.48.48 0 0 1 .035-.358C4.725 8.562 8.159 6.5 11.999 6.5zm-7.115 6.628c1.603 2.009 4.09 3.277 6.806 3.367l.309.005a9.52 9.52 0 0 0 3.191-.572c1.479-.563 2.82-1.528 3.874-2.767l.022-.026a29.893 29.893 0 0 1-14.15.005zM11.999 7.5c-3.23 0-6.135 1.627-7.714 4.201l-.122.206.474.125a28.881 28.881 0 0 0 14.246.123l.539-.138.411-.11-.117-.202c-1.477-2.41-4.116-3.99-7.096-4.185l-.31-.015z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClosed);
export default __webpack_public_path__ + "static/media/eyeClosed.5e6700c452ece37c1ba7af726db9e127.svg";
export { ForwardRef as ReactComponent };